import React, { useState } from "react";
import { Collapse, Divider, List, ListItem } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconExpandLess from "@mui/icons-material/ExpandLess";
import IconExpandMore from "@mui/icons-material/ExpandMore";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

const NestedMenuItem = ({ item, pathname }) => {
  const history = useHistory();
  const [open, setOpen] = useState(() =>
    (item.children || []).some(
      (c) => pathname.split("/")[1] === c.route?.split("/")[0]
    )
  );

  const childSelected = (child) => {
    const parts = child.route.split("/");
    // route like "provisionReport/1"
    if (parts.length > 1) {
      return (
        pathname.split("/")[1] === parts[0] &&
        pathname.split("/")[2] === parts[1]
      );
    }
    return pathname.split("/")[1] === child.route;
  };

  const parentSelected = (item.children || []).some(childSelected);

  return (
    <>
      <ListItem button onClick={() => setOpen((v) => !v)} selected={parentSelected && !open}>
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText primary={item.text} />
        {open ? <IconExpandLess /> : <IconExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {(item.children || []).map((child, idx) => (
            <ListItem
              key={idx}
              button
              sx={{ pl: 4 }}
              selected={childSelected(child)}
              onClick={() => history.push("/" + child.route)}
            >
              <ListItemIcon>{child.icon}</ListItemIcon>
              <ListItemText primary={child.text} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};

const ListItemDropDown = ({ icon, pathname, open, items, text, type, scroll }) => {
  const dispatch = useDispatch();
  const openHandler = async () => {
    !open ? dispatch({ type: `OPEN_${type}` }) : dispatch({ type: `CLOSE_${type}` });
  };
  const history = useHistory();
  return (
    <>
      <ListItem button onClick={openHandler}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
        {open ? <IconExpandLess /> : <IconExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Divider />
        <List
          sx={{ maxHeight: scroll && 700, overflowY: scroll && "scroll" }}
          component="div"
          disablePadding
        >
          {items.map((el, idx) =>
            el.children?.length ? (
              <NestedMenuItem key={idx} item={el} pathname={pathname} />
            ) : (
              <ListItem
                onClick={() => {
                  history.push("/" + el.route);
                }}
                key={idx}
                button
                selected={pathname.split("/")[1] === el.route}
              >
                <ListItemIcon>{el.icon}</ListItemIcon>
                <ListItemText primary={el.text} />
              </ListItem>
            )
          )}
        </List>
      </Collapse>
    </>
  );
};

export default ListItemDropDown;
